export const addLoads = loads => ({
  type: 'ADD_LOADS',
  loads
});

export const selectLoad = load => ({
  type: 'SELECT_LOAD',
  load
});
